import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Routes, Route, Navigate } from "react-router-dom";
import List from "./List/List";
import { New } from "./New/New";
import { Edit } from "./Edit/Edit";
import { BusinessUnitEditLayout } from "./BusinessUnitEditLayout/BusinessUnitEditLayout";
import { TermsConditions } from "./TermsAndConditions/TermsConditions";
import { useAuthorization } from "../../../common/providers/AuthorizationProvider";

const BusinessUnitsMspa = (): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="new" element={<New />} />
      <Route path=":id" element={<BusinessUnitEditLayout />}>
        <Route index element={<Navigate to="edit" replace />} />
        <Route path="edit" element={<Edit />} />
        <Route path="special_conditions" element={<TermsConditions />} />
      </Route>
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default BusinessUnitsMspa;
